import {GETADMIN, GETADMINONE} from '../actions/constant';

const INITIAL_STATE = {list: {}, admin_one: {}};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case GETADMIN:
            return {...state, list:action.payload.data};
        case GETADMINONE:
            return {...state, admin_one:action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_admin.js